import React from "react";
import FacebookOutlinedIcon from "@mui/icons-material/FacebookOutlined";
import TwitterIcon from "@mui/icons-material/Twitter";
import GoogleIcon from "@mui/icons-material/Google";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import PinterestIcon from "@mui/icons-material/Pinterest";
import logo from "../img/logo.png";
const FootBar = () => {
  return (
    <>
      <div className="container">
        <div className="main-footer">
          <div className="footer-ul-1">
            <img src={logo} alt="" />
            <p className="ul-1-p1">
              Lorem ipsum dolor sit amet conse, adipisicing elit. Aspernatur, et
              ipsum dolor sit amet conse?
            </p>
            <span className="footer-icons">
              <FacebookOutlinedIcon />
              <TwitterIcon />
              <GoogleIcon />
              <LinkedInIcon />
              <PinterestIcon />
            </span>
          </div>
          <div className="footer-ul-2">
            <h4>Services</h4>
            <p>Conditions</p>
            <p>Term to use</p>
            <p>Our Services</p>
            <p>New Guests List</p>
            <p>The Team List</p>
          </div>
          <div className="footer-ul-3">
            <h4>Useful Links</h4>
            <p>Conditions</p>
            <p>Term to use</p>
            <p>Our Services</p>
            <p>New Guests List</p>
            <p>The Team List</p>
          </div>
          <div className="footer-ul-4">
            <h4>Subscribe</h4>
            <input
              type="text"
              placeholder="Enter Your Email"
              className="input"
            />
            <button>Subscribe</button>
            <p>
              Get the latest updates via email. Any time you may unsubscribe{" "}
            </p>
          </div>
        </div>
        <div className="footer-title">
          <p>Docfind @ 2022 | All Rights Reserved</p>
          <p>
            Developed By: <span>Kaleem Ullah Moon</span>
          </p>
        </div>
      </div>
    </>
  );
};

export default FootBar;
